import { useLayoutEffect } from 'react';

export default function DarkTheme() {
  useLayoutEffect(() => {
    document.documentElement.style.backgroundColor = '#0f172a';
    document.body.style.backgroundColor = '#0f172a';
    const prev = document.querySelector('meta[name="theme-color"]');
    if (prev) prev.remove();
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = '#0f172a';
    document.head.appendChild(meta);
    return () => {
      document.documentElement.style.backgroundColor = '#479EC3';
      document.body.style.backgroundColor = '';
      const m = document.querySelector('meta[name="theme-color"]');
      if (m) m.remove();
      const restore = document.createElement('meta');
      restore.name = 'theme-color';
      restore.content = '#479EC3';
      document.head.appendChild(restore);
    };
  }, []);

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0,
      height: 'env(safe-area-inset-top)',
      background: '#0f172a',
      zIndex: 9999,
      pointerEvents: 'none',
    }} />
  );
}
